<template lang="pug">
  .wrapper
    DashboardSidebar
    .main-panel
      DashboardNavbar
      DashboardContent
      DashboardFooter
</template>

<script>
import { mapState } from 'vuex'
import DashboardSidebar from '@/components/layouts/DashboardSidebar'
import DashboardNavbar from '@/components/layouts/DashboardNavbar'
import DashboardContent from '@/components/layouts/DashboardContent'
import DashboardFooter from '@/components/layouts/DashboardFooter'

export default {
  components: {
    DashboardSidebar,
    DashboardNavbar,
    DashboardContent,
    DashboardFooter
  },
  computed: {
    ...mapState('crumbs', ['crumbs'])
  }
}
</script>
